import {clientLog} from "../clientLog";
import {damsFetch} from "../app/damsFetch";

export const publishingTagsSearchHandler = async () => {
    try {
        const response = await damsFetch('/publishing-tags', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response?.models) {
            return response?.models;
        } else {
            return [];
        }
    } catch (error) {
        clientLog('error',
            'Error fetching publishing tags:' + error.toString(),
            'publishingtagssearchhandler');
    }
};